<template>
  <!-- 网络状态提示 -->
  <el-alert
    :title="networkStatusText"
    :type="networkStatusType"
    :closable="false"
    v-if="showNetworkAlert"
  />
</template>

<script>
export default {
  data() {
    return {
      isOffline: false, // 是否断网
      connection: null,
      downloadSpeed: "未知",
      isWeakNetwork: false,
      showNetworkAlert: false,
      networkStatusText: "",
      networkStatusType: "info",
    };
  },
  mounted() {
    this.initNetworkMonitoring();
  },
  beforeDestroy() {
    this.unregisterNetworkListeners();
  },
  methods: {
    // 初始化网络监控
    initNetworkMonitoring() {
      // 检查浏览器支持
      if (!("connection" in navigator)) {
        console.log("Network Information API 不受支持");
        return;
      }

      this.connection = navigator.connection;
      console.log("初始化网络信息：", this.connection);
      this.updateNetworkInfo();

      // 监听网络变化
      this.connection.addEventListener("change", this.updateNetworkInfo);

      // 监听 online/offline 事件（兼容更广泛）
      window.addEventListener("online", this.updateNetworkInfo);
      window.addEventListener("offline", this.updateNetworkInfo);
    },

    // 更新网络信息
    updateNetworkInfo() {
      const { effectiveType, rtt, downlink } = this.connection;
      console.log("网络信息：", effectiveType, rtt, downlink, navigator.onLine);

      // 更新下载速度
      this.downloadSpeed = downlink
        ? `${(downlink * 1000).toFixed(0)} Kbps`
        : "未知";

      const isOfflineByConnection = this.connection
        ? this.connection.downlink === 0
        : false;
      const isOfflineByOnline = !navigator.onLine;

      // 断网状态：两种判断方式取“或”（更可靠）
      this.isOffline = isOfflineByConnection || isOfflineByOnline;

      // 判断网络质量
      this.isWeakNetwork = this.checkWeakNetwork(effectiveType, rtt, downlink);

      // 更新提示
      this.updateNetworkAlert();
    },

    // 判断是否为弱网
    checkWeakNetwork(effectiveType, rtt, downlink) {
      return (
        effectiveType === "slow-2g" ||
        effectiveType === "2g" ||
        (effectiveType === "3g" && rtt > 500) ||
        (downlink && downlink < 0.5) // 带宽低于 0.5 Mbps
      );
    },

    // 更新网络提示
    updateNetworkAlert() {
      console.log("updateNetworkAlert", this.isWeakNetwork, this.isOffline);
      if (this.isOffline) {
        console.log("当前处于断网状态");
        this.networkStatusText = "当前处于断网状态";
        this.networkStatusType = "warning";
        this.showNetworkAlert = true;
      } else if (this.isWeakNetwork) {
        this.networkStatusText =
          "当前网络连接较弱，部分功能可能受限, 当前网络速率 " +
          this.downloadSpeed;
        this.networkStatusType = "warning";
        this.showNetworkAlert = true;
      } else {
        this.showNetworkAlert = false;
      }
    },

    // 取消监听
    unregisterNetworkListeners() {
      if (this.connection) {
        this.connection.removeEventListener("change", this.updateNetworkInfo);
      }

      window.removeEventListener("online", this.updateNetworkInfo);
      window.removeEventListener("offline", this.updateNetworkInfo);
    },
  },
};
</script>
